import { useDropzone } from 'react-dropzone';
import { Camera } from 'lucide-react';
import { cn } from '../../lib/utils';
import { UploadProps } from './types';
import RejectionFiles from './errors/RejectionFiles';
import AvatarPreview from './preview/AvatarPreview';

// ----------------------------------------------------------------------

export default function UploadAvatar({
  error,
  file,
  disabled,
  helperText,
  className,
  ...other
}: UploadProps) {
  const { getRootProps, getInputProps, isDragActive, isDragReject, fileRejections } = useDropzone({
    multiple: false,
    disabled,
    ...other
  });

  const hasFile = !!file;
  const isError = isDragReject || !!error;

  return (
    <>
      <div
        {...getRootProps()}
        className={cn(
          'group relative mx-auto flex h-36 w-36 cursor-pointer items-center justify-center overflow-hidden rounded-full border border-dashed border-border',
          isDragActive && 'opacity-70',
          isError && 'border-destructive',
          disabled && 'pointer-events-none opacity-50',
          className
        )}
      >
        <input {...getInputProps()} />

        {hasFile && <AvatarPreview file={file} />}

        <div
          className={cn(
            'absolute inset-2 z-10 flex flex-col items-center justify-center rounded-full bg-muted text-muted-foreground transition-opacity hover:opacity-70',
            hasFile && 'bg-gray-900/60 text-white opacity-0 group-hover:opacity-100',
            isError && 'bg-destructive/20 text-destructive'
          )}
        >
          <Camera className="mb-1 h-6 w-6" />
          <span className="text-xs">{file ? 'Update photo' : 'Upload photo'}</span>
        </div>
      </div>

      {helperText}

      <RejectionFiles fileRejections={fileRejections} />
    </>
  );
}
